import { ReactNode, useMemo } from 'react'
import { Location, useLocation } from 'react-router-dom'

import { getRouteNameFromPath, RouteNames } from '@/routes'

export function LocationHandler({
  children,
}: {
  children: (p: { routeName: RouteNames; location: Location }) => ReactNode
}) {
  const location = useLocation()
  const pathname = useMemo(() => location.pathname, [location.pathname])
  const routeName = useMemo(() => getRouteNameFromPath(pathname), [pathname])
  return <>{children({ routeName, location })}</>
}
